import request from '@/router/axios';
//根据pageUrl获取数据表字段详情列表
export const getOrderFLowDetail = (id) => {
    return request({
      url: `/api/v4ward/out/order/setting/detail/${id}`,
      method: 'get',
      params: {
      },
    });
  };

//   "/api/v4ward/projectDict/dictionary?code=project_partner_type&projectId={{key}}"

//根据pageUrl获取数据表字段详情列表
export const getTimeoutNotifyStrategy = () => {
    return request({
      url: `/api/blade-system/dict/dictionary?code=order_timeout_notify_strategy`,
      method: 'get',
      params: {
      },
    });
  };
export const getOrderScoreList = () => {
    return request({
      url: `/api/blade-system/dict/dictionary?code=order_score`,
      method: 'get',
      params: {
      },
    });
  };

